import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { Navigate, useParams } from "react-router";

import { getThreediModelsApi } from "../../apiConfiguration";
import { APP_BASE_HREF } from "../../App";

// There is no models detail page! We only redirect new models to the corresponding
// schematisation / revision page, and others back to the models list.
const ModelsDetail: FC = () => {
  const { id } = useParams<{ id: string }>();

  const threediModelsApi = getThreediModelsApi();

  const idNumber = parseInt(id!, 10);

  const modelsResponse = useQuery({
    queryKey: ["threedimodel", id],
    queryFn: () => threediModelsApi.threedimodelsRead({ id: idNumber }),
    enabled: !isNaN(idNumber),
  });

  const noSuchModel = isNaN(idNumber) || modelsResponse.isError;

  if (noSuchModel) {
    return <Navigate replace to="/models" />;
  }

  const model = modelsResponse.isSuccess ? modelsResponse.data : null;

  if (model) {
    if (model.schematisationId && model.revisionId) {
      return (
        <Navigate
          replace
          to={`${APP_BASE_HREF}/schematisations/${model.schematisationId}/${model.revisionId}`}
        />
      );
    } else {
      // Old model - no detail page.
      return <Navigate replace to="/models" />;
    }
  } else {
    return null; // Waiting for response
  }
};

export default ModelsDetail;
